import 'scss/services/line2mic.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { toUrl, getQueryString } from 'js/libs/utils'
import { floatMenu } from 'js/libs/utils-float-menu'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
initServiceOpen({
  modalTitle: '申请购买双麦克风阵列',
  defaultTip: '请选择您使用双麦克风阵列的应用，也可以创建新应用再申请购买',
  unOpenTitle: '选择应用',
  alertTip: '请选择您使用麦克风阵列的应用',
  enableOpen: false
})
$(function () {
  var url = window.location.href
  if (url.indexOf('?') !== -1) {
    var data = getQueryString('orderFlag')
    if (data === '-1') {
      jAlert('请先购买麦克风阵列再访问')
    }
  }
  $('.to-service-open').click(function () {
    goServiceBuy({
      packageId: '3001004'
    }, {
      callback: function () {
        showserviceOpenModal()
      }
    })
  })
  $('.to-purchase-matters').click(function () {
    floatMenu.methods.toPosition('purchase-matters')
  })
  $('.to-set-awken').click(function () {
    toUrl('/services/line2mic/line2micAwaken')
  })
  serviceQA()
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/line2mic.js